import { render, staticRenderFns } from "./ProductsComponent.vue?vue&type=template&id=5c70ddd4&scoped=true&"
import script from "./ProductsComponent.vue?vue&type=script&lang=js&"
export * from "./ProductsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProductsComponent.vue?vue&type=style&index=0&id=5c70ddd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c70ddd4",
  null
  
)

export default component.exports